<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { usePinnedSidebarItems } from 'dashboard/composables/usePinnedSidebarItems';

const props = defineProps({
  pinKey: { type: String, required: true },
});

const { t } = useI18n();
const { isPinned, togglePin } = usePinnedSidebarItems();

const pinned = computed(() => isPinned(props.pinKey));
</script>

<template>
  <button
    type="button"
    class="peer absolute top-1/2 -translate-y-1/2 ltr:right-1 rtl:left-1 z-10 grid size-6 place-content-center rounded-md hover:bg-n-alpha-2 focus-visible:opacity-100 group-hover/pin:opacity-100 [@media(hover:none)]:opacity-100"
    :class="pinned ? 'opacity-100 text-n-brand' : 'opacity-0 text-n-slate-11'"
    :title="pinned ? t('SIDEBAR.UNPIN_ITEM') : t('SIDEBAR.PIN_ITEM')"
    :aria-pressed="pinned"
    @click.prevent.stop="togglePin(pinKey)"
  >
    <span class="i-lucide-pin size-3.5" />
  </button>
</template>
